/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { FC } from 'react';

import { grayPalette } from '@tcl-argon-colors/colors';

const { gray45 } = grayPalette;

const __CardContainer = css`
  height: 100%;
  width: 100%;
  padding: 1.5em 0.5em 1.5em 1.5em;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 4px ${gray45};
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: ${gray45};
  &::-webkit-scrollbar-thumb {
    border-radius: 16px;
    background: ${gray45};
    border: 6px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }
  &::-webkit-scrollbar {
    border: none;
    width: 16px;
  }
  &::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

const CardContainer: FC = ({ children }) => (
  <div aria-label="card" css={__CardContainer}>
    {children}
  </div>
);

/**
 * The Card component must be passed a single child.
 * The child will take up the entire area of the Card
 */
interface CardProps {
  children: JSX.Element;
}
const Card: FC<CardProps> = ({ children }: CardProps): JSX.Element => <CardContainer>{children}</CardContainer>;

export default Card;
